// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
footer[data-v-bab94dfc] {
    background-color: #333333;
    height: 2.5rem;
    flex-wrap: nowrap;
    padding: 0.5rem 1rem;
    z-index: 1030;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    color: white;
    font-size: 14px;
    font-weight: 300;
    
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.documents[data-v-bab94dfc] {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}
.mail-link[data-v-bab94dfc] {
    color: white;
    text-decoration: underline;
}
@media screen and (max-width: 650px) {
footer[data-v-bab94dfc] {
        flex-direction: column;
        height: 6rem;
}
.documents[data-v-bab94dfc] {
        flex-direction: column;
}
}
`, "",{"version":3,"sources":["webpack://./../components/FooterInfomir.vue"],"names":[],"mappings":";AAmEA;IACA,yBAAA;IACA,cAAA;IACA,iBAAA;IACA,oBAAA;IACA,aAAA;IACA,eAAA;IACA,SAAA;IACA,QAAA;IACA,OAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;;IAEA,aAAA;IACA,mBAAA;IACA,8BAAA;AACA;AAEA;IACA,aAAA;IACA,mBAAA;IACA,WAAA;AACA;AAEA;IACA,YAAA;IACA,0BAAA;AACA;AAEA;AACA;QACA,sBAAA;QACA,YAAA;AACA;AAEA;QACA,sBAAA;AACA;AACA","sourcesContent":["<template>\n    <footer>\n        <div class=\"documents\">\n            <router-link to=\"/user-agreement\" target=\"_blank\" class=\"mail-link\">\n                {{ $t('title.userAgreement') }}\n            </router-link>\n            \n            <router-link to=\"/privacy-policy\" target=\"_blank\" class=\"mail-link\">\n                {{ $t('title.privacyPolicy') }}\n            </router-link>\n        </div>\n        \n        <div class=\"footer-text pl-3\">\n            {{ $t('message.anyProblems') }}<a class=\"mail-link pl-1\" href=\"https://support.infomir.ru/open.php\" target=\"_blank\">{{ $t('button.letterUs') }}</a>\n        </div>\n    </footer>\n</template>\n\n<script>\n    export default {\n        name: 'FooterInfomir'\n    };\n</script>\n\n<style scoped>\n    footer {\n        background-color: #333333;\n        height: 2.5rem;\n        flex-wrap: nowrap;\n        padding: 0.5rem 1rem;\n        z-index: 1030;\n        position: fixed;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        color: white;\n        font-size: 14px;\n        font-weight: 300;\n        \n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n    \n    .documents {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n    }\n\n    .mail-link {\n        color: white;\n        text-decoration: underline;\n    }\n    \n    @media screen and (max-width: 650px) {\n        footer {\n            flex-direction: column;\n            height: 6rem;\n        }\n        \n        .documents {\n            flex-direction: column;\n        }\n    }\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
